import { render, staticRenderFns } from "./SolicitudReclamacionesResult.vue?vue&type=template&id=666436e5&scoped=true"
import script from "./SolicitudReclamacionesResult.vue?vue&type=script&lang=ts"
export * from "./SolicitudReclamacionesResult.vue?vue&type=script&lang=ts"
import style0 from "./SolicitudReclamacionesResult.vue?vue&type=style&index=0&id=666436e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666436e5",
  null
  
)

export default component.exports